import type { IconProps } from '../types/IconProps.ts';
export const GenericLayout: IconProps = {
    name: 'GenericLayout',
    children: [
        `<rect width="18" height="18" x="3" y="3" rx="2" />`,
        `<path d="M3 9h18M12 9v12" />`,
    ]
};